/* Winefields - liga o autoplay do banner principal.

   O tema inicializa o slideshow em assets/engo-scripts.js com autoplay:!1
   (false), fixo no bundle minificado, e nao expoe isso como configuracao no
   editor. Em vez de reescrever o bundle, esperamos o slick terminar de
   inicializar e ligamos o autoplay pela API dele.

   Para mudar o tempo de cada banner, altere WF_INTERVALO (em milissegundos). */

(function () {
  var WF_INTERVALO = 6000;
  var WF_SELETOR = '.slick-side-h1';
  var tentativas = 0;

  function ligar() {
    tentativas++;

    if (!window.jQuery) {
      if (tentativas < 80) setTimeout(ligar, 250);
      return;
    }

    var $slider = window.jQuery(WF_SELETOR);
    if (!$slider.length || !$slider[0].slick) {
      if (tentativas < 80) setTimeout(ligar, 250);
      return;
    }

    var el = $slider[0];
    if (el.getAttribute('data-wf-autoplay')) return;

    // Com um slide so nao ha o que rodar.
    if (el.slick.slideCount < 2) return;

    el.setAttribute('data-wf-autoplay', '1');

    try {
      $slider.slick('slickSetOption', 'autoplaySpeed', WF_INTERVALO, false);
      $slider.slick('slickSetOption', 'pauseOnHover', true, false);
      $slider.slick('slickSetOption', 'autoplay', true, false);
      $slider.slick('slickPlay');
    } catch (e) {
      el.removeAttribute('data-wf-autoplay');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(ligar, 300); });
  } else {
    setTimeout(ligar, 300);
  }
})();
